(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-entity-pim-az"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = () => {
    document.querySelectorAll('[data-cc-pim-root]:not([data-cc-pim-ready])').forEach((root) => {
      const source = root.querySelector('[data-cc-pim-source]');
      if (!source) return;
      const entries = [...source.children].filter((item) => item.tagName === 'LI');
      if (!entries.length) return;
      const lang = root.dataset.ccPimLanguage || document.documentElement.lang || 'fr';
      const collator = new Intl.Collator(lang, { sensitivity: 'base' });
      const getName = (item) => item.dataset.ccPimName || item.textContent.trim();
      entries.sort((a, b) => collator.compare(getName(a), getName(b)));
      if (lang.toLowerCase().startsWith('zh')) {
        source.replaceChildren(...entries);
        root.dataset.ccPimReady = 'true';
        return;
      }
      const initial = (value) => {
        const first = Array.from(value.trim())[0] || '#';
        const normalized = first.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleUpperCase(lang);
        const ligatures = { 'Œ': 'O', 'Æ': 'A', 'Ø': 'O', 'Ł': 'L', 'Đ': 'D', 'Ð': 'D' };
        const letter = ligatures[normalized] || normalized;
        return /^[A-Z\u0391-\u03A9\u0400-\u04FF]$/u.test(letter) ? letter : '#';
      };
      const groups = new Map();
      const output = document.createElement('div');
      output.className = 'cc-entity-az__groups';
      for (const item of entries) {
        const letter = initial(getName(item));
        let group = groups.get(letter);
        if (!group) {
          const block = document.createElement('section');
          block.className = 'cc-entity-az__group';
          block.id = root.id + '-letter-' + (groups.size + 1);
          const heading = document.createElement('h2');
          heading.textContent = letter;
          const list = document.createElement('ul');
          block.append(heading, list);
          group = { letter, id: block.id, list, block };
          groups.set(letter, group);
        }
        group.list.append(item);
      }
      const navigation = document.createElement('nav');
      navigation.className = 'cc-entity-az__alphabet';
      navigation.setAttribute('aria-label', root.dataset.ccPimLabel || 'Alphabet');
      const orderedGroups = [...groups.values()].sort((a, b) => {
        if (a.letter === '#') return 1;
        if (b.letter === '#') return -1;
        return collator.compare(a.letter, b.letter);
      });
      output.replaceChildren(...orderedGroups.map((group) => group.block));
      for (const group of orderedGroups) {
        const link = document.createElement('a');
        link.href = '#' + group.id;
        link.textContent = group.letter;
        navigation.append(link);
      }
      source.replaceWith(output);
      root.prepend(navigation);
      root.dataset.ccPimReady = 'true';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
